<div class="ttmodal" id="schematicWindow">
  <div id="schematicWindowHeader" class="ttmodal__header">
    <span class="ttmodal__title">Schematic Components Recognition</span>
    <div class="panel__header__button-container" id="closeButton">

      <a class="button waves-effect" (click)="onCloseClick()">
        <i class="material-icons button__icon">cancel</i>
        <span class="button__text">Close</span>
      </a>
    </div>
  </div>
  <div class="ttmodal__body">
    <div class="container">
      <div class="main-layout">

        <div style="display: flex; flex-direction: column; width: 50%; min-width: 640px; ">
          <div class="comp-type-wrapper">
            <div style="display: flex; flex-direction: row; justify-content: space-between; ">
              <div>
                <mat-form-field class="header-form-full-width" style="width: 262px;" hasBackdrop="false">
                  <span style="align-self: center; min-width: 102px;">Component Type</span>
                  <mat-select [formControl]="ComponentTypeVMForm" #matSelectCompType (selectionChange)="saveUpdateComponentType(ComponentTypeVM)"
                              multiple>
                    <mat-option *ngFor="let component of componentTypeList"
                                [value]="component.Id">{{component.Name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div style="margin-top: 14px; display: none;">
                <button mat-raised-button color="warn" (click)="saveUpdateComponentType(ComponentTypeVM)">
                  <i class="material-icons button__icon">save</i><span class="button__text">
                    Save
                  </span>
                </button>
              </div>
            </div>

          </div>
          <!-- LEFT -->
          <div class="image-wrapper">
            <div class="pan-zoom-container"
                 [style.transform]="transformStyle">

              <img #image [src]="sanitize(schematicData)" />

              <canvas #canvas
                      (click)="onCanvasClick($event)"
                      (mousemove)="onMouseMove($event)"
                      (mouseenter)="onCanvasEnter()"
                      (mouseleave)="onCanvasLeave()"
                      (mouseout)="onCanvasLeave()">
              </canvas>
              <a style="display:none;" class="button margin-right-8"><span style="color: red; font-style: italic;" (click)="finishShape()">Finish Component</span></a>

            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; width: 50%; ">
          <div class="side-panel-start">
            <div> <h5>Click on the diagram to add points to define area covered by component.</h5></div>
          </div>
          <!-- RIGHT -->
          <div class="side-panel-start">

            <div class="side-panel">
              <div *ngFor="let shape of shapes; let i = index" class="shape-block">
                <!-- Component + Location in one row -->
                <div class="component-row">
                  <div class="separator"></div>
                  <div class="gap10">
                    <!-- Component dropdown -->
                    <select [(ngModel)]="shape.componentId" class="width100" (change)="SetComponentGroupNumber(shape.componentId, shape)">
                      <option [ngValue]="null">Select Component</option>
                      <option *ngFor="let c of componentList" [ngValue]="c.Id"> <!--[disabled]="isComponentUsed(c.Id, shape)"-->
                        {{ c.Name }}
                      </option>
                    </select>
                    <!-- Points -->
                    <div class="points-list">
                      <div class="point-row" *ngFor="let p of shape.points; let pi = index">

                        <div class="point-field">
                          <label>X:</label>
                          <input type="number"
                                 step="any"
                                 [(ngModel)]="p.x"
                                 (ngModelChange)="redraw()"
                                 class="point-input" />
                        </div>

                        <div class="point-field">
                          <label>Y:</label>
                          <input type="number"
                                 step="any"
                                 [(ngModel)]="p.y"
                                 (ngModelChange)="redraw()"
                                 class="point-input" />
                        </div>
                      </div>
                      <div class="center-align">
                        <a class="button margin-right-8"><span style="color: red; font-style: italic;" (click)="ClearAllXY(shape)">{{ shape.points.length > 0 ? "Clear Coordinates" : "Mark Again" }}</span></a>
                      </div>
                    </div>
                  </div>
                  <div class="separator"></div>
                  <!-- Location input -->
                  <div class="location-inline">

                    <!-- Input + Add -->
                    <div class="location-input-row">
                      <input type="text" title="Press enter to add location"
                             [(ngModel)]="shape.newLocation"
                             placeholder="Location"
                             (keydown.enter)="addLocation(shape)" />

                      <button type="button"
                              class="icon-btn add"
                              (click)="addLocation(shape)"
                              title="Add Location">
                        +
                      </button>
                    </div>
                    <!-- Location list -->
                    <div class="location-list">
                      <div class="location-row"
                           *ngFor="let loc of shape.locations; let j = index">

                        <!--<span class="location-name">{{ loc.LocationName }}</span>-->
                        <input 
                               type="text"
                               [(ngModel)]="loc.LocationName"
                                />
                        
                        <button type="button"
                                class="icon-btn remove"
                                (click)="removeLocation(shape, j)"
                                title="Delete Location">
                          ✖
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="separator"></div>
                </div>
              </div>
            </div>
          </div>
        </div>



      </div>
    </div>

    <div class="ttmodal__footer single-row">

      <!-- LEFT TOOLBAR -->
      <div class="left-tools">

        <!-- Draw New -->
        <button mat-raised-button (click)="ClearAllXY(null)" title="Start new shape">
          Mark New
        </button>

        <!-- Pan Controls (Left / Up) -->
        <div class="pan-inline">
          <button mat-raised-button class="pan-mat" (click)="panLeft()">⬅️</button>
          <button mat-raised-button class="pan-mat" (click)="panUp()">⬆️</button>
        </div>

        <!-- Zoom Controls -->
        <div class="zoom-controls">
          <button mat-raised-button class="zoom-box" (click)="zoomOut()" title="Zoom Out">−</button>

          <span class="zoom-text">{{ zoom | number:'1.1-1' }}x</span>

          <button mat-raised-button class="zoom-box" (click)="zoomIn()" title="Zoom In">+</button>
        </div>


        <!-- Pan Controls (Down / Right) -->
        <div class="pan-inline">
          <button mat-raised-button class="pan-mat" (click)="panDown()">⬇️</button>
          <button mat-raised-button class="pan-mat" (click)="panRight()">➡️</button>
        </div>
        <div>
          <button mat-raised-button (click)="resetCanvas()" title="Reset image posotion">
            Reset
          </button>
        </div>
      </div>

      <!-- RIGHT ACTIONS -->
      <div class="right-actions">
        <button mat-raised-button (click)="onCloseClick()">Cancel</button>

        <button mat-raised-button
                color="warn"
                [disabled]="loading"
                [class.loading]="loading"
                (click)="saveAllShapes()">
          <i class="material-icons button__icon">save</i>
          <span class="button__text">Save</span>
        </button>
      </div>

    </div>

  </div>
</div>
